import { ILogin, IError } from '.'

export interface ILoginState {
  data: ILogin
  socialToken: string
  loginCompleted: boolean
  isLoading: boolean
  error: IError | null
}

export const initialState: ILoginState = {
  data: {
    accessToken: '',
    expiresIn: 0,
    refreshToken: '',
    success: false,
    tokenType: '',
  },
  socialToken: '',
  loginCompleted: false,
  isLoading: false,
  error: null,
}
